import { Notice } from '@/components/ui/Notice'
import { Section, SectionHeading } from '@/components/ui/Section'
import { ContactTimeline } from '@/features/countdown'
import { SiteList } from '@/features/expedition/SiteList'
import { useDocumentMeta } from '@/hooks/useDocumentMeta'
import { useI18n } from '@/i18n'

export function ExpeditionPage() {
  const { t } = useI18n()
  useDocumentMeta({ title: t.expedition.heading, description: t.expedition.lead })

  return (
    <>
      <Section>
        <SectionHeading
          eyebrow={t.expedition.eyebrow}
          title={t.expedition.heading}
          lead={t.expedition.lead}
        />
        <div className="mt-6">
          <Notice>{t.common.draftHint}</Notice>
        </div>
        <h2 className="eyebrow mt-10">{t.expedition.sitesHeading}</h2>
        <div className="mt-5">
          <SiteList />
        </div>
        <p className="mt-6 text-sm text-faint">{t.expedition.note}</p>
      </Section>

      <Section className="hairline">
        <SectionHeading
          eyebrow={t.timeline.eyebrow}
          title={t.timeline.heading}
          lead={t.timeline.lead}
        />
        <div className="mt-8">
          <ContactTimeline />
        </div>
        <p className="mt-5 text-sm text-faint">{t.timeline.safetyNote}</p>
      </Section>
    </>
  )
}
